'use client';
import { faPlay } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { activateTrial } from '@/api/requests/trials';
import { useAccount } from '@/hooks/useAccount';
import { useRouter } from 'next/navigation';
import { getSourcePath } from '@/rewrites';
import { useState } from 'react';

interface ActivateTrialButtonProps {
  isSubscriptionVersion?: boolean;
}

const ActivateTrialButton = ({ isSubscriptionVersion }: ActivateTrialButtonProps) => {
  const [isActivating, setIsActivating] = useState(false);
  const { customer, refreshCustomer } = useAccount();
  const router = useRouter();

  const handleActivateTrial = async () => {
    if (!customer?.currentTrial?.id) return;

    setIsActivating(true);
    try {
      await activateTrial(customer.currentTrial.id);
      await refreshCustomer();

      if (!isSubscriptionVersion) {
        router.push(getSourcePath('/subscription'));
      }
    } finally {
      setIsActivating(false);
    }
  };

  return (
    <button
      onClick={handleActivateTrial}
      disabled={isActivating}
      className="flex items-center rounded-md bg-base-100 px-3 py-1 text-sm font-medium text-primary"
    >
      <span className="mr-1">
        <FontAwesomeIcon icon={faPlay} />
      </span>
      {isActivating ? 'Wird aktiviert...' : 'Testphase starten'}
    </button>
  );
};

export default ActivateTrialButton;
